<svg [attr.height]='height' [attr.width]='width'>
    <g class="ball">
      <use [attr.xlink:href]='hash' [attr.width]='width' [attr.height]='height' x='0' y='0'><title>{{title}}</title></use>
    </g>
</svg>